export default {"src":"/_next/static/media/beta-desktop-default.c394e907.svg","height":100,"width":415,"blurWidth":0,"blurHeight":0};